import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Box, Spinner } from "@chakra-ui/react";
import { isAuthorized } from "../../helpers/helpers";
import { AnalyticsHubPage } from "./components/AnalyticsHubPage";
import { MaintenanceRevenuePage } from "./components/MaintenanceRevenuePage";
import { TalentUnlockRevenuePage } from "./components/TalentUnlockRevenuePage";
import { BUSINESS_ANALYTICS_ROLES } from "./constants";
import { useUserRoles } from "./hooks/useUserRoles";

export default function Analytics() {
  const { roles, loading } = useUserRoles();

  if (loading) {
    return (
      <Box p={6} display="flex" justifyContent="center">
        <Spinner color="brand.500" />
      </Box>
    );
  }

  if (!isAuthorized(BUSINESS_ANALYTICS_ROLES, roles)) {
    return <Redirect to="/" />;
  }

  return (
    <Switch>
      <Route path="/analytics/maintenance">
        <MaintenanceRevenuePage />
      </Route>
      <Route path="/analytics/talent-unlocks">
        <TalentUnlockRevenuePage />
      </Route>
      <Route path="/analytics">
        <AnalyticsHubPage />
      </Route>
    </Switch>
  );
}
